import { Fragment } from "react";

function ComposedInputToggle({
  toggleProps,
  inputProps,
  label,
  labelDesc,
  inputLabel,
  leftText = "No",
  rightText = "Yes",
}) {
  return (
    <Fragment>
      <div>
        <p>{label}</p>
        <label className="switch">
          <input
            type="checkbox"
            checked={toggleProps.checked}
            onChange={toggleProps.onChange}
            name={toggleProps.name}
          />
          <span></span>
          <div>{leftText}</div>
          <div>{rightText}</div>
        </label>
      </div>

      {toggleProps.checked && (
        <div>
          <div>
            <input {...inputProps} className="form-input" />
          </div>
        </div>
      )}
    </Fragment>
  );
}

export default ComposedInputToggle;
